// Message-related constants

export const QUICK_REACTIONS = ['❤️', '👍', '😂', '😮', '😢', '🙏'];

export const MESSAGE_POSITIONS = {
  SINGLE: 'single',
  FIRST: 'first',
  MIDDLE: 'middle',
  LAST: 'last',
};

export const TYPING_EMIT_DELAY = 1000; // 1 second
export const TYPING_TIMEOUT = 3000; // 3 seconds

export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed',
};

export const CHAT_EVENTS = {
  USER_TYPING: 'USER_TYPING',
  MESSAGE_REACTION: 'MESSAGE_REACTION',
  MESSAGE_REACTION_UPDATE: 'MESSAGE_REACTION_UPDATE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  MESSAGE_RECEIVED: 'MESSAGE_RECEIVED',
};
